import React, { useEffect, useRef, useState } from "react";
import { Button, Card, FloatingBubble, Image, Mask, SafeArea, SideBar } from "antd-mobile";
import { CloseCircleFill, AddOutline } from "antd-mobile-icons";
import "./index.scss";
import TrophyText from "@/components/trophyText";
import http from "@/api";
import { getGarmentList, getGarmentTypeList } from "./api";
import dayjs from "dayjs";
import { getQuery } from "@/utils/operationUrl";
import getImageSize from "@/utils/getImageSize";

interface TabsItem {
    id: number;
    name: string;
    badge: string;
}

const Home: React.FC = () => {
    const [visible, setVisible] = useState(false);
    const [tabs, setTabs] = useState<TabsItem[]>([]);
    const [checkTabs, setCheckTabs] = useState<string>("");
    const backRef = useRef({});
    const [list, setList] = useState<any[]>([]); // 列表数据
    const [details, setDetails] = useState<any>({}); // 详情数据
    const [obj, setObj] = useState<any>(1);
    const [fz, setFz] = useState(false);
    const {type} = getQuery()
    const closeModal = () => {
        setVisible(false);
    };
    useEffect(() => {
        getGarmentTypeList().then((res) => {
            setTabs(res?.data || []);
            const checkId = type ? type : res?.data?.[0]?.id;
            setCheckTabs(checkId);
        });
    }, []);
    useEffect(() => {
        if (checkTabs) {
            getGarmentList(checkTabs).then((res) => {
                setList(res?.data || []);
            });
        }
    }, [checkTabs]);
    useEffect(() => { }, []);
    const aaa = () => {
        var touchState: any = null;
        let container: any = backRef.current;
        console.log(container, "container");
        let time = 0
        container.addEventListener(
            "touchstart",
            function (evt) {
                time = new Date() * 1
                touchState = {
                    startX: evt.touches[0].pageX,
                    startY: evt.touches[0].pageY,
                    endX: evt.touches[0].pageX,
                    endY: evt.touches[0].pageY,
                    startX2: evt.touches[1] ? evt.touches[1].pageX : -1,
                    startY2: evt.touches[1] ? evt.touches[1].pageY : -1,
                    endX2: evt.touches[1] ? evt.touches[1].pageX : -1,
                    endY2: evt.touches[1] ? evt.touches[1].pageY : -1,
                };
            },
            false
        );
        container.addEventListener(
            "touchmove",
            function (evt) {
                if (touchState === null) {
                    return;
                }
                if (new Date() * 1 - time > 300) {
                    time = new Date() * 1
                    cc()
                }
                touchState.endX = evt.touches[0].pageX;
                touchState.endY = evt.touches[0].pageY;
                touchState.endX2 = evt.touches[1] ? evt.touches[1].pageX : -1;
                touchState.endY2 = evt.touches[1] ? evt.touches[1].pageY : -1;

                function cc() {
                    // 计算两点的距离
                    var getDistance = function (startX, startY, endX, endY) {
                        return Math.hypot(endX - startX, endY - startY);
                    };
                    if (
                        touchState.startX2 !== -1 &&
                        touchState.endX2 !== -1 &&
                        touchState.startY2 != -1 &&
                        touchState.endY2 !== -1
                    ) {
                        let distanceStart = getDistance(
                            touchState.startX,
                            touchState.startY,
                            touchState.startX2,
                            touchState.startY2
                        );
                        let distanceEnd = getDistance(
                            touchState.endX,
                            touchState.endY,
                            touchState.endX2,
                            touchState.endY2
                        );
                        //起始时两点距离和结束时两点距离进行比较，判断是放大还是缩小
                        if (distanceStart < distanceEnd) {
                            // todo
                            setObj((obj) => {
                                return obj + 0.2;
                            });
                        } else if (distanceStart > distanceEnd) {
                            // todo
                            setObj((obj) => {
                                return obj - 0.2;
                            });
                        }
                    }
                }
            },
            false
        );
        container.addEventListener(
            "touchend",
            function (evt) {
                if (touchState === null) {
                    return;
                }
                // 计算两点的距离
                var getDistance = function (startX, startY, endX, endY) {
                    return Math.hypot(endX - startX, endY - startY);
                };
                if (
                    touchState.startX2 !== -1 &&
                    touchState.endX2 !== -1 &&
                    touchState.startY2 != -1 &&
                    touchState.endY2 !== -1
                ) {
                    let distanceStart = getDistance(
                        touchState.startX,
                        touchState.startY,
                        touchState.startX2,
                        touchState.startY2
                    );
                    let distanceEnd = getDistance(
                        touchState.endX,
                        touchState.endY,
                        touchState.endX2,
                        touchState.endY2
                    );
                    //起始时两点距离和结束时两点距离进行比较，判断是放大还是缩小
                    if (distanceStart < distanceEnd) {
                        // todo
                        setObj((obj) => {
                            return obj + 0.2;
                        });
                    } else if (distanceStart > distanceEnd) {
                        // todo
                        setObj((obj) => {
                            return obj - 0.2;
                        });
                    }
                }
            },
            false
        );
    };
    return (
        <>
            <div>
                {/* <SafeArea position='top' /> */}
                <div
                    style={{ height: "4rem", background: "rgb(160 133 74 / 3%)" }}
                ></div>
                <div className="home">
                    <div className="home-left">
                        <SideBar
                            onChange={(id: any) => setCheckTabs(id)}
                            activeKey={`${checkTabs}`}
                        >
                            {tabs.map((item) => (
                                <SideBar.Item
                                    key={`${item.id}`}
                                    title={item.name}
                                // badge={item.badge}
                                />
                            ))}
                        </SideBar>
                    </div>
                    <div className="home-right">
                        {list.length === 0 ? (
                            <>
                                <div className="home-right-empty">
                                    <div className="home-right-empty-img"></div>
                                    <div style={{ fontSize: "1.8rem" }}>请添加或者上传衣服</div>
                                    <div style={{ marginTop: "1.4rem" }}>该分类暂无衣服哟</div>
                                    <div style={{ marginTop: "1.4rem" }}>
                                        <Button
                                            onClick={() => {
                                                window.location.href = `/#/garment?type=${checkTabs}`;
                                            }}
                                            size="mini"
                                            style={{ color: "#a0854a", opacity: "1" }}
                                        >
                                            去添加
                                        </Button>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <>
                                {list?.map((item) => {
                                    return (
                                        <div className="home-right-card">
                                            <div className="home-right-card-img">
                                                <Image
                                                    height={"25vh"}
                                                    onClick={() => {
                                                        setDetails(item);
                                                        setVisible(true);
                                                    }}
                                                    src={getImageSize(item.imageUrl,'180')}
                                                    fit="cover"
                                                ></Image>
                                            </div>
                                            <div className="home-right-card-footer">{item.name}</div>
                                        </div>
                                    );
                                })}
                            </>
                        )}
                    </div>
                    <div>
                        <Mask
                            visible={visible}
                            onMaskClick={() => setVisible(false)}
                            opacity={0.3}
                        >
                            <div className={`home-mask ${!visible ? "home-close" : ""}`}>
                                <div className="flip-card">
                                    <div
                                        onClick={() => {
                                            aaa();
                                            setFz(!fz);
                                        }}
                                        className={`flip-card-inner ${fz ? "annimate1" : ""}`}
                                    >
                                        <div className="flip-card-front">
                                            <div>
                                                <div>
                                                    <Image
                                                        height={"40vh"}
                                                        width={"42vh"}
                                                        onClick={() => setVisible(true)}
                                                        src={getImageSize(details.imageUrl,'450')}
                                                        fit="cover"
                                                    ></Image>
                                                </div>
                                                <div className="home-right-card-footer">
                                                    <TrophyText />
                                                    <div style={{ fontSize: "1.2rem", color: "#2c6d00" }}>
                                                        {dayjs(details.operateTime).format(
                                                            "YYYY-MM-DD HH:mm:ss"
                                                        )}
                                                    </div>
                                                    <div
                                                        style={{ fontSize: "1.8rem", textAlign: "center" }}
                                                    >
                                                        <span
                                                            style={{
                                                                color: "white",
                                                                background: "#7aba866e",
                                                                padding: "5px 20px",
                                                                borderRadius: "0.8rem",
                                                            }}
                                                        >
                                                            {details.name}
                                                        </span>
                                                    </div>
                                                    <div
                                                        style={{
                                                            fontSize: "1.2rem",
                                                            color: "rgb(122 186 134)",
                                                            padding: "5px 20px",
                                                        }}
                                                    >
                                                        {details.remark}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flip-card-back" ref={backRef}>
                                            <div style={{ position: "absolute", top: "0" }}>
                                                {JSON.stringify(obj, null, 2)}
                                            </div>
                                            <Image
                                                style={{
                                                    borderRadius: ".6rem",
                                                    transform: `scale(${obj})`,
                                                }}
                                                width={"100%"}
                                                height={"100%"}
                                                onClick={() => setVisible(true)}
                                                src={getImageSize(details.imageUrl,'450')}
                                                fit="cover"
                                            ></Image>
                                        </div>
                                    </div>
                                    <div className="home-mask-close">
                                        <span onClick={closeModal}>
                                            <CloseCircleFill />
                                        </span>
                                        <div className="home-mask-close-bg"></div>
                                    </div>
                                </div>
                            </div>
                        </Mask>
                    </div>
                </div>
            </div>
            {list.length !== 0 &&<FloatingBubble
                axis='xy'
                magnetic='x'
                onClick={()=>{
                    window.location.href=`/#/garment?type=${checkTabs}`
                }}
                style={{
                    '--initial-position-bottom': '5rem',
                    '--initial-position-right': '4rem',
                    '--edge-distance': '24px',
                    '--background': '#685632'
                }}
            >
                <AddOutline fontSize={32} />
            </FloatingBubble>}
        </>
    );
};

export default Home;
